<template lang="pug">
.dropdown
  slot(name="trigger")
    a.dropdown-toggle.btn(
      :class="allTriggerClasses"
      role="button"
      data-toggle="dropdown"
    )
      .d-flex.align-items-center
        span.m-0
          | {{ label }}
        i.hi.hi-10(:class="iconClass")
  ul.dropdown-menu(:class="directionClass")
    slot
</template>

<script>
export default {
  name: 'AppDropdown',
  props: {
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
    },
    direction: {
      type: String,
      default: 'right',
    },
    triggerClasses: {
      type: String,
    },
    icon: {
      type: String,
      default: 'caret',
    },
  },
  computed: {
    allTriggerClasses() {
      return [this.typeClass, this.sizeClass, this.triggerClasses, this.disabledClass].join(' ');
    },
    typeClass() {
      return `btn-${this.type}`;
    },
    disabledClass() {
      return this.disabled ? 'disabled' : '';
    },
    sizeClass() {
      switch (this.size) {
        case 'small':
          return 'btn-sm';
        case 'large':
          return 'btn-lg';
        default:
          return '';
      }
    },
    directionClass() {
      return `dropdown-menu-${this.direction}`;
    },
    iconClass() {
      return `hi-${this.icon}`;
    },
  },
};
</script>
